<template>
  <div>
    <b-badge v-if="availableVersions.length > 0"
             pill
             variant="secondary"
             class="d-flex align-items-center px-2 py-1">
      Purchased
      <i class="fas fa-check ml-1"/>
    </b-badge>
    <a v-else :href="assetPublicUrl(asset)" class="d-flex align-items-center">
      <b-badge pill variant="primary" class="d-flex align-items-center px-2 py-1">
        BUY NOW
      </b-badge>
    </a>
  </div>
</template>
<script>
import GeneralMixins from "../../mixins/GeneralMixins";

export default {
  props: ['asset', 'availableVersions'],
  mixins: [GeneralMixins]
}
</script>